import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withStyles, CircularProgress, Fab, Tooltip } from '@material-ui/core';
import { Check as CheckIcon } from '@material-ui/icons';

class FormSaveButton extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        sendFunc: PropTypes.func.isRequired,
        sendLoading: PropTypes.bool.isRequired,
        positionClassName: PropTypes.string
    };

    static defaultProps = {
        positionClassName: null
    };

    render() {
        const { sendFunc, sendLoading, positionClassName, classes } = this.props;
        const positionClass = positionClassName ? positionClassName : classes.firstPosition;

        if (sendLoading)
            return (
                <div className={positionClass}>
                    <CircularProgress size={25} />
                </div>
            );
        return (
            <div className={positionClass}>
                <Tooltip title={Translator.translate('general.save')} placement="top">
                    <Fab
                        aria-label={Translator.translate('general.save')}
                        className={`${classes.btnEdit} ${classes.fabSave}`}
                        size="small"
                        onClick={sendFunc}
                    >
                        <CheckIcon className={classes.icon} />
                    </Fab>
                </Tooltip>
            </div>
        );
    }
}

const styles = theme => ({
    firstPosition: {
        position: 'absolute',
        top: 50,
        right: 50,
        [theme.breakpoints.down('md')]: {
            top: 30,
            right: 30
        },
        [theme.breakpoints.down('sm')]: {
            top: 20,
            right: 20
        },
        [theme.breakpoints.down('xs')]: {
            top: 18,
            right: 18
        }
    },

    fabSave: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white
    },
    btnEdit: {
        marginLeft: 10,
        minHeight: 30,
        minWidth: 30,
        [theme.breakpoints.down('xs')]: {
            height: 30,
            width: 30
        }
    },
    icon: {
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.2rem'
        }
    }
});

export default withStyles(styles, { withTheme: true })(FormSaveButton);



// WEBPACK FOOTER //
// ./data/components/FormSaveButton.js